import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { ContainerVm } from 'qp-ui-interface';
import { takeUntil } from 'rxjs/operators';
import { DataService } from 'src/app/data.service';
import { Destroyable } from 'src/app/shared/services/destroyable';
import { NavigationLibraryService } from 'src/app/shared/services/navigation/navigation.service';
import { MyAhaService } from '../../my-aha.service';

@Component({
  selector: 'app-my-aha-main',
  templateUrl: './my-aha-main.component.html',
  styleUrls: ['./my-aha-main.component.scss'],
})
export class MyAhaMainComponent
  extends Destroyable
  implements OnInit, OnDestroy
{
  @Input() isFromLanguageSelection: boolean = false;
  @Input() isFromSettings: boolean = false;
  @Input() selectedProfileIndex: number;

  bookmarks: ContainerVm;
  favourites: ContainerVm;
  rentals: ContainerVm;

  constructor(
    private readonly myAhaService: MyAhaService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly navService: NavigationLibraryService,
    private readonly dataService: DataService,
    private readonly router: Router
  ) {
    super();
  }

  ngOnInit(): void {
    this.initialiseObserver();
    this.dataService.currentUrl = this.router.url;
    if (!this.isFromLanguageSelection && !this.isFromSettings) {
      // this.navService.focusContainer('main-container', false, 0, false);
      // this.navService.setIndexContainer('main-container', 0);
    }
  }

  ngOnDestroy(): void {
    this.cleanup();
  }

  initialiseObserver() {
    this.myAhaService.bookmarks$
      .pipe(takeUntil(this.destroy$))
      .subscribe((bookmarks) => {
        if (bookmarks?.resources?.length) {
          this.bookmarks = bookmarks;
          this.changeDetectorRef.detectChanges();
        }
      });

    this.myAhaService.favourites$
      .pipe(takeUntil(this.destroy$))
      .subscribe((favourites) => {
        if (favourites?.resources?.length) {
          this.favourites = favourites;
          this.changeDetectorRef.detectChanges();
        }
      });

    this.myAhaService.rentals$
      .pipe(takeUntil(this.destroy$))
      .subscribe((rentals) => {
        if (rentals?.resources?.length) {
          this.rentals = rentals;
          this.changeDetectorRef.detectChanges();
        }
      });
  }

  focusIn(id: string, index: number) {
    this.dataService.myahaContentIndex = index;
    const horizontalCarouselHeader = document.getElementById(id);
    if (horizontalCarouselHeader) {
      horizontalCarouselHeader.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }
  focusUp(currentContainerClass: string) {
    // Logic to focus the next container upwards based on the length of resources arrays
    if (currentContainerClass === 'rentals-container') {
      if (this.favourites?.resources?.length > 0) {
        const getIndex = this.navService.getIndexContainer(
          'horizontal-carousel-cards-1'
        );
        this.navService.focusContainer('watchlists-container', true, getIndex);
      } else if (this.bookmarks?.resources?.length > 0) {
        const getIndex = this.navService.getIndexContainer(
          'horizontal-carousel-cards-0'
        );
        this.navService.focusContainer('bookmarks-container', true, getIndex);
      } else {
        this.focusTopPanel();
      }
    } else if (currentContainerClass === 'watchlists-container') {
      if (this.bookmarks?.resources?.length > 0) {
        const getIndex = this.navService.getIndexContainer(
          'horizontal-carousel-cards-0'
        );
        this.navService.focusContainer('bookmarks-container', true, getIndex);
      } else {
        this.focusTopPanel();
      }
    } else if (currentContainerClass === 'bookmarks-container') {
      this.focusTopPanel();
    } else {
      // Default fallback
    }
  }

  private focusTopPanel() {
    this.dataService.myahaContentIndex = null;
    this.navService.setIndexContainer('top-panel', this.selectedProfileIndex);
    this.navService.focusContainer(
      'top-panel',
      true,
      this.selectedProfileIndex,
      true
    );
  }

  focusDown(currentContainerClass: string) {
    if (currentContainerClass === 'bookmarks-container') {
      if (this.favourites?.resources?.length > 0) {
        const getIndex = this.navService.getIndexContainer(
          'horizontal-carousel-cards-1'
        );
        this.navService.focusContainer(
          'watchlists-container',
          true,
          getIndex,
          true
        );
      } else if (this.rentals?.resources?.length > 0) {
        const getIndex = this.navService.getIndexContainer(
          'horizontal-carousel-cards-2'
        );
        this.navService.focusContainer(
          'rentals-container',
          true,
          getIndex,
          true
        );
      }
    } else if (currentContainerClass === 'watchlists-container') {
      if (this.rentals?.resources?.length > 0) {
        const getIndex = this.navService.getIndexContainer(
          'horizontal-carousel-cards-2'
        );
        this.navService.focusContainer(
          'rentals-container',
          true,
          getIndex,
          true
        );
      }
    }
  }

  onKeyDown(event: KeyboardEvent, focusCont: string) {
    if (event.isUp()) {
      this.focusUp(focusCont);
    } else if (event.isDown()) {
      this.focusDown(focusCont);
      event.stopPropagation();
    }
  }

  clearData() {
    this.myAhaService.clearData();
  }
}
